module.exports = __webpack_public_path__ + "61c122eb3e7aa637d7a8540bdb3cc992.pdf";